import * as kind from './kind';

export { default as className } from 'classnames';

type IDelegate<I = any, O = any> = (...e: I[]) => O;

export const handle = (delegate?: IDelegate, map?: IDelegate, defer?: number): IDelegate | undefined => {
  if (!delegate) return;

  const handler = (map ? (...e: any[]) => {
    const execute = (args: any) => {
      return (kind.isArray(args) ? delegate(...args) : delegate(args));
    };

    const args = map(...e);

    return (kind.isPromise(args) ? args.then(execute) : execute(args));
  } : delegate);
  if (handler && kind.isNumber(defer)) return (...e: any[]) => setTimeout(() => handler(...e), defer);

  return handler;
};

export const element = (tag: string, props?: Record<string, any>): any => {
  const node = document.createElement(tag);
  if (props) Object.assign(node, props);

  return node;
};
